import React from 'react';
import ReactMarkdown from 'react-markdown';

const AIChatPanel = ({
  showAIChat,
  chatMessages,
  isTyping,
  chatInput,
  setChatInput,
  sendChatMessage,
  handleChatKeyPress,
  chatEndRef,
  onRetryMessage
}) => {
  if (!showAIChat) return null;

  return (
    <div className={`glass-ai-chat-panel ${showAIChat ? 'visible' : ''}`}>
      <div className="glass-chat-header">
        <h3>🎯 Your Business Coach</h3>
        <p>Immediate coaching based on your journal</p>
      </div>
      <div className="glass-chat-messages">
        {chatMessages.map((message, index) =>
          message.role === 'error' ? (
            <div key={index} className="glass-chat-message error">
              <div className="message-content">
                <div className="glass-chat-error-input" style={{ opacity: 0.55 }}>{message.content}</div>
                {message.errorText && (
                  <>
                    <div className="glass-chat-error-text">{message.errorText}</div>
                    <button className="chat-retry-btn" onClick={onRetryMessage}>Retry</button>
                  </>
                )}
              </div>
            </div>
          ) : (
            <div key={index} className={`glass-chat-message ${message.role}`}>
              <div className="message-content">
                <ReactMarkdown>{message.content}</ReactMarkdown>
              </div>
            </div>
          )
        )}
        {isTyping && (
          <div className="glass-chat-message assistant typing">
            <div className="message-content">
              Your coach is analyzing your journal and preparing strategic insights...
            </div>
          </div>
        )}
        <div ref={chatEndRef} />
      </div>
      <div className="glass-chat-input-section">
        <textarea
          value={chatInput}
          onChange={(e) => setChatInput(e.target.value)}
          onKeyPress={handleChatKeyPress}
          placeholder="Continue the coaching conversation..."
          className="glass-chat-input"
          rows="2"
        />
        <button 
          onClick={sendChatMessage}
          disabled={!chatInput.trim() || isTyping}
          className="glass-send-button"
        >
          Send
        </button>
      </div>
    </div>
  );
};

export default AIChatPanel; 